import type { CapitalNeed } from '#/graphql/types';
import type { ColumnProps } from '#/common/components/DataGrid';
import { CAPITAL_NEED_STATUSES, CAPITAL_NEED_TYPES } from '../../utils/constants';
import { withChip } from '#/common/utils/wrappers';
import { color } from '@nuvolo/nuux-theme/utils';
import type { CustomChipColors } from '#/common/utils/wrappers/withChip';

export const capitalNeedStatusColors: Record<string, CustomChipColors> = {
  draft: {
    backgroundColor: color('info', 'dark', 0.15),
    textColor: color('info', 'dark'),
  },
  planned: {
    backgroundColor: color('warn', 'light', 0.15),
    textColor: color('warn', 'light'),
  },
  processed: {
    backgroundColor: color('success', 'dark', 0.15),
    textColor: color('success', 'dark'),
  },
  rejected: {
    backgroundColor: color('error', 'dark', 0.15),
    textColor: color('error', 'dark'),
  },
};

const columns: ColumnProps<CapitalNeed>[] = [
  { dataField: 'id', caption: 'ID', visible: false, showInColumnChooser: false },
  {
    dataField: 'displayNumber',
    caption: 'Number',
    visible: true,
    openOnClick: true,
    fixed: true,
    dataType: 'string',
  },
  {
    dataField: 'assetId',
    caption: 'AssetId',
    visible: false,
    dataType: 'string',
    showInColumnChooser: false,
  },
  {
    dataField: 'title',
    caption: 'Title',
    visible: true,
    openOnClick: true,
    dataType: 'string',
  },
  {
    dataField: 'type',
    caption: 'Type',
    visible: true,
    dataType: 'string',
    lookup: {
      nullable: true,
      dataSource: CAPITAL_NEED_TYPES,
      displayExpr: 'label',
      valueExpr: 'value',
    },
  },
  {
    dataField: 'status',
    caption: 'Status',
    visible: true,
    dataType: 'string',
    lookup: {
      nullable: true,
      dataSource: CAPITAL_NEED_STATUSES,
      displayExpr: 'label',
      valueExpr: 'value',
    },
    cellRender: (e) => {
      const value = (e.value as string) || 'draft';
      const label = e.value ? e.displayValue || '' : 'Draft';
      const customColors = capitalNeedStatusColors[value];
      return withChip(label, 'normal', customColors);
    },
  },
  {
    dataField: 'plannedDate',
    caption: 'Planned Date',
    visible: true,
    dataType: 'date',
  },
  {
    dataField: 'cost',
    caption: 'Planned Cost',
    visible: true,
    dataType: 'number',
    format: {
      type: 'currency',
      precision: 2,
    },
  },
];

export default columns;
